import {
  StyledDrawer
} from "./chunk-VWZQUWMP.mjs";

// src/components/drawer/drawer-content.tsx
import * as Dialog from "@radix-ui/react-dialog";
import React, { forwardRef } from "react";
var DrawerContent = forwardRef(
  function DrawerContent2({ portalRef, ...props }, ref) {
    return /* @__PURE__ */ React.createElement(Dialog.DialogPortal, { container: portalRef }, /* @__PURE__ */ React.createElement(StyledDrawer.Overlay, null), /* @__PURE__ */ React.createElement(StyledDrawer.Content, { ref, ...props }));
  }
);

export {
  DrawerContent
};
